import React, { useEffect } from 'react';
import { DataGridPro } from '@mui/x-data-grid-pro';
import { useTranslation } from 'react-i18next';
import { ContextMenu } from './ContextMenu';

import { useScheduleDesviationTable } from 'hooks/scheduleDesviation/useScheduleDesviationTable';

const ScheduleDesviationTable = () => {
    const { t } = useTranslation();

    const { rows, loading, reloading, selected, setSelected, selectedRow, setSelectedRow, contextMenu, setContextMenu, columns, cleanSelected } = useScheduleDesviationTable();

    useEffect(() => {
        reloading();
    }, [reloading]);

    return (
        <>
            <div
                style={{ width: '100%', height: '100%' }}
                onContextMenu={(event) => {
                    event.preventDefault();
                    setContextMenu(contextMenu === null ? { mouseX: event.clientX + 2, mouseY: event.clientY - 6 } : null);
                }}
            >
                <DataGridPro
                    columns={columns}
                    rows={rows}
                    showCellVerticalBorder
                    showColumnVerticalBorder
                    headerFilters
                    localeText={{
                        headerFilterOperatorContains: t('general.table.headerFilters.headerFilterOperatorContains'),
                        headerFilterOperatorEquals: t('general.table.headerFilters.headerFilterOperatorEquals'),
                        headerFilterOperatorStartsWith: t('general.table.headerFilters.headerFilterOperatorStartsWith'),
                        headerFilterOperatorEndsWith: t('general.table.headerFilters.headerFilterOperatorEndsWith'),
                        headerFilterOperatorIsEmpty: t('general.table.headerFilters.headerFilterOperatorIsEmpty'),
                        headerFilterOperatorIsNotEmpty: t('general.table.headerFilters.headerFilterOperatorIsNotEmpty'),
                        footerRowSelected: (count) =>
                            count > 1
                                ? `${t('general.table.footerFilters.footerRowSelected.>1', { count, countFormatted: count.toLocaleString() })} `
                                : `${t('general.table.footerFilters.footerRowSelected.=1', { count, countFormatted: count.toLocaleString() })}`,

                        footerTotalRows: t('general.table.footerFilters.footerTotalRows'),
                        MuiTablePagination: {
                            labelDisplayedRows: ({ from, to, count }) =>
                                t('general.table.footerFilters.labelDisplayedRows', {
                                    from,
                                    to,
                                    count,
                                }),
                            labelRowsPerPage: t('general.table.footerFilters.labelRowsPerPage'),
                        },
                    }}
                    disableColumnMenu
                    loading={loading}
                    checkboxSelection
                    onRowSelectionModelChange={(newRowSelectionModel) => {
                        let row = rows.filter((row: any) => newRowSelectionModel.includes(row.id));
                        setSelected(newRowSelectionModel);
                        setSelectedRow(row);
                    }}
                    rowSelectionModel={selected}
                    pagination
                    sx={{
                        height: 'calc(100vh - 140px)',
                    }}
                />

                <ContextMenu contextMenu={contextMenu} setContextMenu={setContextMenu} selectedRow={selectedRow} reloading={reloading} rows={rows} cleanSelected={cleanSelected} />
            </div>
        </>
    );
};

export { ScheduleDesviationTable };
